(() => {
  if (window.AlawooderHomeHero) {
    window.AlawooderHomeHero.init(document);
    return;
  }

  const mounted = new Map();
  const pad = (number) => String(number).padStart(2, '0');

  const mount = (root) => {
    if (mounted.has(root)) return;
    const track = root.querySelector('[data-home-hero-track]');
    const slides = [...root.querySelectorAll('[data-home-hero-slide]')];
    if (!track || !slides.length) return;
    const captions = [...root.querySelectorAll('[data-home-hero-caption]')];
    const prev = root.querySelector('[data-home-hero-prev]');
    const next = root.querySelector('[data-home-hero-next]');
    const count = root.querySelector('[data-home-hero-count]');
    const controller = new AbortController();
    const { signal } = controller;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let active = 0;
    let requested = null;
    let scrollFrame = 0;
    let resizeFrame = 0;
    let trackWidth = track.clientWidth;

    const slideLeft = (slide) => slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    const update = () => {
      slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', String(index !== active));
        slide.querySelectorAll('a').forEach((link) => { link.tabIndex = index === active ? 0 : -1; });
      });
      captions.forEach((caption, index) => { caption.hidden = index !== active; });
      const navigationIndex = requested ?? active;
      if (prev) prev.disabled = navigationIndex === 0;
      if (next) next.disabled = navigationIndex === slides.length - 1;
      if (count) count.textContent = `${pad(active + 1)} / ${pad(slides.length)}`;
    };
    const select = (index, instant = false) => {
      const target = Math.max(0, Math.min(slides.length - 1, index));
      const immediately = instant || reduceMotion.matches;
      requested = target;
      if (immediately) active = target;
      update();
      track.scrollTo({ left: slideLeft(slides[target]), behavior: immediately ? 'instant' : 'smooth' });
    };
    const nearest = () => {
      let closest = 0;
      let distance = Infinity;
      slides.forEach((slide, index) => {
        const nextDistance = Math.abs(slideLeft(slide) - track.scrollLeft);
        if (nextDistance < distance) { distance = nextDistance; closest = index; }
      });
      return closest;
    };

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-home-hero-prev]')) select((requested ?? active) - 1);
      if (event.target.closest('[data-home-hero-next]')) select((requested ?? active) + 1);
    }, { signal });
    track.addEventListener('keydown', (event) => {
      let index;
      if (event.key === 'ArrowLeft') index = (requested ?? active) - 1;
      if (event.key === 'ArrowRight') index = (requested ?? active) + 1;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = slides.length - 1;
      if (index === undefined) return;
      event.preventDefault();
      select(index);
    }, { signal });
    track.addEventListener('scroll', () => {
      if (resizeFrame) return;
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = 0;
        const index = nearest();
        if (index !== active) { active = index; update(); }
      });
    }, { passive: true, signal });

    track.addEventListener('scrollend', () => {
      requested = null;
      active = nearest();
      update();
    }, { signal });
    const beginGesture = () => { requested = null; };
    track.addEventListener('pointerdown', beginGesture, { passive: true, signal });
    track.addEventListener('wheel', beginGesture, { passive: true, signal });

    const observer = new ResizeObserver(() => {
      if (Math.abs(track.clientWidth - trackWidth) < 0.5) return;
      trackWidth = track.clientWidth;
      cancelAnimationFrame(scrollFrame);
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = 0;
        select(active, true);
      });
    });
    observer.observe(track);
    const blockSelect = (event) => {
      const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail?.blockId);
      if (index >= 0) select(index, true);
    };
    document.addEventListener('shopify:block:select', blockSelect, { signal });
    update();
    mounted.set(root, () => {
      controller.abort();
      observer.disconnect();
      cancelAnimationFrame(scrollFrame);
      cancelAnimationFrame(resizeFrame);
    });
  };

  const init = (scope) => {
    if (scope.matches?.('[data-home-hero]')) mount(scope);
    scope.querySelectorAll('[data-home-hero]').forEach(mount);
  };
  const destroy = (scope) => {
    mounted.forEach((cleanup, root) => {
      if (scope === root || scope.contains(root)) { cleanup(); mounted.delete(root); }
    });
  };
  window.AlawooderHomeHero = { init, destroy };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
  init(document);
})();
